module.exports = __webpack_public_path__ + "static/SBQH-title-fc194c005a80e6d3cf95e7b3bd06a626.png";